import TooltipController  from "@/js/Webmail/TooltipController.js";
import LanguageController from "@/js/Shared/Language/Language";

export { TooltipDirective as default };

const TooltipDirective = {
  created(el, binding, vnode, prevVnode) {
    if (!binding.value) {
      return;
    }

    el.hasToolTip = false;
    el.setAttribute('data-text', binding.value);
    el.setAttribute('aria-label', LanguageController.say(binding.value));

    el.showToolTip = async () => {
      if (el.classList.contains('dropdown-active') || el.parentNode.classList.contains('dropdown-active')) {
        return;
      }

      if (el.getAttribute('data-tooltip-visible') === 'false') {
        return;
      }

      TooltipController.text     = binding.value;
      TooltipController.target   = el;
      TooltipController.display  = true;
      TooltipController.position = binding.arg || null;
      el.hasToolTip = true;
    }

    el.removeToolTip = () => {
      if (TooltipController.display === false) {
        return;
      }

      TooltipController.display  = false;
      TooltipController.text     = null;
      TooltipController.target   = null;
      TooltipController.position = null;
      el.hasToolTip = false;
    }
  },

  async unmounted(el) {
    if (el.hasToolTip) {
      el.removeToolTip();
    }

    el.removeEventListener('mouseenter', el.showToolTip);
    el.removeEventListener('mouseleave', el.removeToolTip);
    el.removeEventListener('wheel'     , el.removeToolTip);
    el.removeEventListener('click'     , el.removeToolTip);
  },

  mounted(el) {
    el.addEventListener('mouseenter', el.showToolTip);
    el.addEventListener('mouseleave', el.removeToolTip);
    el.addEventListener('wheel'     , el.removeToolTip, {passive: true});
    el.addEventListener('click'     , el.removeToolTip);
  },
}
